import { fetchApi, getUserId } from 'shared/functions';

export const fetchCreditReviewLevels = () =>
  fetchApi(`/sig/api/storefront/ratings/`).then((response: Response) => response.json());

export const fetchCreditReviewSpecs = () =>
  fetchApi(`/sig/api/specifications/legend/`).then((response: Response) => response.json());

export const fetchCreditReviewChartsData = (easyNumber: string) =>
  fetchApi(`/sig/api/charts-data/${easyNumber}/`).then((response: Response) => response.json());

export const requestCreditReviewRatings = ({ ids, userId, organisationId }: any) => {
  const items = ids.map((id: string) => ({
    organisationId,
    artifactId: id,
  }));

  const params = {
    method: 'POST',
    body: JSON.stringify(items),
  };

  return fetchApi(
    `/sig/api/storefront/users/${userId}/request-history-add-item/`,
    params,
  ).then((response: Response) => response.json());
};

export const fetchCreditReviewContractData = () => {
  const userId = getUserId();

  return fetchApi('/sig/api/contract-data/')
    .then(res => res.json())
    .then(
      ({
        users,
        allowed_requests: allowedRequests,
        total_amount: totalAmount,
        contract_state: contractState,
      }) => ({
        cofaceRequestPermission: users.includes(userId),
        cofaceRequestsAllowed: allowedRequests,
        cofaceTotalAmount: totalAmount,
        cofaceContractState: contractState,
      }),
    );
};
